import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 000. CSRFトークン
 */
export const csrfToken = (): Promise<any> => {
  return axios.get(`/api/csrf_token`, {});
};

export const useCsrfToken = () => {
  return useQuery({
    queryKey: ['csrf_token'],
    queryFn: () => csrfToken(),
  });
};
